import { render, staticRenderFns } from "./BarChartAlarmeJeObjektkategorieTraplinked.vue?vue&type=template&id=685e7776"
import script from "./BarChartAlarmeJeObjektkategorieTraplinked.vue?vue&type=script&lang=js"
export * from "./BarChartAlarmeJeObjektkategorieTraplinked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports